import { post, get } from '@kit/utils/APIV1.js'

//https://localhost/cms-service/index.php/wp-json/v1/home
export const contactUsForm = async(jsonFormData) => {
  return post(`contact-us-form`, jsonFormData)
}

export const contactUs = async() => {
  return get(`contact-us/id/41`)
}